import { render, staticRenderFns } from "./PgaSelect.vue?vue&type=template&id=408eee30&"
import script from "./PgaSelect.vue?vue&type=script&lang=ts&"
export * from "./PgaSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('408eee30')) {
      api.createRecord('408eee30', component.options)
    } else {
      api.reload('408eee30', component.options)
    }
    module.hot.accept("./PgaSelect.vue?vue&type=template&id=408eee30&", function () {
      api.rerender('408eee30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/PgaSelect.vue"
export default component.exports